<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Test Sms</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item>
            <ion-label position="stacked">Cell Phone</ion-label>
            <ion-input type="tel" [(ngModel)]="vm.cellPhones" data-test="cellPhones"
                placeholder="Comma separated cell numbers: 6618778631, 8186749956"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Text Message</ion-label>
            <ion-input type="text" [(ngModel)]="vm.textMessage" data-test="textMessage"></ion-input>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="sendButton" expand="full" (click)="onSendTextClick()">Send Text Message</ion-button>
    </ion-toolbar>
</ion-footer>